export default "__VITE_ASSET__8f4f8d7b__"